/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A countable, bookable resource at a clinic (e.g. an IV chair). Concerns reference it by id via booking_resource_id; the slot engine caps overlapping appointments at count.
 * @export
 * @interface BookingResource
 */
export interface BookingResource {
    /**
     * Stable slug, unique within the clinic. Matches ^[a-z0-9_-]+$.
     * @type {string}
     * @memberof BookingResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BookingResource
     */
    name: string;
    /**
     * How many of this resource the clinic has. Integer >= 1.
     * @type {number}
     * @memberof BookingResource
     */
    count: number;
}

/**
 * Check if a given object implements the BookingResource interface.
 */
export function instanceOfBookingResource(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function BookingResourceFromJSON(json: any): BookingResource {
    return BookingResourceFromJSONTyped(json, false);
}

export function BookingResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingResource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'count': json['count'],
    };
}

export function BookingResourceToJSON(value?: BookingResource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'count': value.count,
    };
}

